import { useTranslation } from 'next-i18next';
import { EmailStroke } from '@oresundsbron/icons';
import { ContactInfoLine, ContactLink } from '.';

export const EmailaddressLine = ({ email }: { email: string }) => {
  const { t } = useTranslation(['club'], { nsMode: 'fallback' });

  return (
    <ContactInfoLine lastElement={true}>
      <ContactLink href={`mailto:${email}`}>
        <div className="mr-4 flex items-center sm:mr-0">
          <EmailStroke className="text-primary-950 group-hover:text-primary-950" />
          <span className="ml-4 hidden text-primary-950 group-hover:!text-primary-950 sm:inline ">
            {t('club.contactInformation.email')}
          </span>
        </div>
        <span className="text-primary-700  underline-offset-2 group-hover:underline">
          {email}
        </span>
      </ContactLink>
    </ContactInfoLine>
  );
};
